import { useQuery } from "@tanstack/react-query";
import styled from "styled-components";
import CasesApi from "../../api/cases/index.js";
import Loader from "../Loader.js";

const UserProgressInfo = styled(({ className, caseInfo }) => {
  const { data } = useQuery({
    queryKey: [
      "cases",
      "list",
      { uuid: caseInfo.uuid, include_user_progress: true },
    ],
    queryFn: () =>
      CasesApi.getCases({
        uuid: caseInfo.uuid,
        include_user_progress: true,
      }),
  });

  if (!data) return <Loader />;

  const caseData = data[0];

  return (
    <div className={className}>
      <h4 style={{ marginBottom: 5 }}>My Case Progress</h4>
      <div className="detail-item">
        <div className="detail-label">Tasks</div>
        <div className="detail-value">
          {`${caseData.user_progress.completed_tasks} / ${caseData.user_progress.total_tasks}`}
        </div>
      </div>
      <div className="detail-item">
        <div className="detail-label">Evidence Items</div>
        <div className="detail-value">
          {`${caseData.user_progress.completed_evidence} / ${caseData.user_progress.total_assigned_evidence}`}
        </div>
      </div>
      <div className="detail-item">
        <div className="detail-label">QA Reviews</div>
        <div className="detail-value">
          {`${caseData.user_progress.completed_qa_reviews} / ${caseData.user_progress.total_qa_reviews}`}
        </div>
      </div>
    </div>
  );
})`
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: ${({ theme }) => theme.palette.text.primary};

  .detail-item {
    display: flex;
    flex-direction: row;
    gap: 5px;
    font-size: 0.7rem;
  }

  .detail-label {
    width: 100px;
    font-weight: bold;
    color: ${({ theme }) => theme.palette.text.secondary};
  }

  .detail-value {
    margin-left: auto;
  }
`;

export default UserProgressInfo;
